import React, { useState } from "react";
import { TouchableOpacity, Text, StyleSheet, View, Image } from "react-native";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppColors } from "../utility/AppColors";
import { AppImages } from "../utility/AppImages";
import InviteSocialMediaModal from "../screens/Auth/Event/InviteSocialMediaModal";

interface ShareComponentProps {
  accessToken: string;
  item?: any;
  height?: number;
  width?: number;
  eventType?: string;
  eventID?: string;
}

const ShareComponent: React.FC<ShareComponentProps> = ({
  accessToken,
  item,
  height = 30,
  width = 29,
  eventType = "HomeScreen",
  eventID = "",
}) => {
  const [isShare, setIsShare] = useState(false);

  return (
    <>
      <TouchableOpacity
        onPress={() => {
          setIsShare(true);
        }}
        style={{ marginTop: 5, flex: 1 }}
      >
        <Image
          source={AppImages.icshare}
          style={{ height: height, width: width, bottom: 3 }}
        />
      </TouchableOpacity>
      {isShare && (
        <InviteSocialMediaModal
          accessToken={accessToken}
          challengeDetails={item}
          showModal={isShare}
          setShowModal={setIsShare}
          eventType={eventType}
          status={item?.status}
          eventID={eventID}
          heading={"Share on social media"}
        />
      )}
    </>
  );
};

export default ShareComponent;
